module.exports = __webpack_public_path__ + "static/media/the-search-for-carbon-neutral-protein.8d3ed723.jpg";